import React from 'react';
import AgentConversation from '../../agents/shared/AgentConversation';
import { profilingAgentSpec } from './spec';

/**
 * Thin wrapper — the chat implementation is the shared
 * AgentConversation (one chat for every agent, no duplication).
 * The Profiling Agent's rich MessageBubble + detail-card tools are
 * supplied via `profilingAgentSpec`.
 */
const ConversationPage: React.FC = () => (
  <AgentConversation spec={profilingAgentSpec} />
);

export default ConversationPage;
